/*
 * Return boolean. Does values have any valid contact information?
 * At least 1 email address or 1 phone number is valid.
 * A complete home address is valid.
 */
export const hasSingleContact = ({
  email,
  work_email,
  home_phone,
  cell_phone,
  work_phone,
  address,
  city,
  state,
  zip
}) => {
  const filterFunc = i => i && i.length > 0
  const arr = [email, work_email, home_phone, cell_phone, work_phone].filter(
    filterFunc
  )
  const validAddress = [address, city, state, zip].filter(filterFunc)
  return arr.length > 0 || validAddress.length === 4
}
